import React from 'react';
import { cn } from '../lib/utils';

type ButtonVariant = 'solid' | 'outline' | 'ghost';
type ButtonSize = 'sm' | 'md';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  size?: ButtonSize;
}

export const Button: React.FC<ButtonProps> = ({
  variant = 'solid',
  size = 'md',
  className,
  children,
  ...props
}) => {
  return (
    <button
      className={cn(
        'adslot-btn',
        variant === 'outline'
          ? 'adslot-btn-outline'
          : variant === 'ghost'
            ? 'adslot-btn-ghost'
            : 'adslot-btn-solid',
        size === 'sm' ? 'adslot-btn-sm' : 'adslot-btn-md',
        className,
      )}
      {...props}
    >
      {children}
    </button>
  );
};
